/**
 * Product API Data Sources
 *
 * Exports all product-related API data sources for unified access
 */

export {ProductAPIDataSource as ProductAPIDataSourceCore} from './ProductAPIDataSource';
export {ProductBrandAPIDataSource} from './ProductBrandAPIDataSource';
export {ProductTagAPIDataSource} from './ProductTagAPIDataSource';
export {ProductTypeAPIDataSource} from './ProductTypeAPIDataSource';

// Combined data source object for backward compatibility
import {ProductAPIDataSource as ProductAPIDataSourceCore} from './ProductAPIDataSource';
import {ProductBrandAPIDataSource} from './ProductBrandAPIDataSource';
import {ProductTagAPIDataSource} from './ProductTagAPIDataSource';
import {ProductTypeAPIDataSource} from './ProductTypeAPIDataSource';

export const ProductAPIDataSourceCombined = {
  ...ProductAPIDataSourceCore,
  getBrands: ProductBrandAPIDataSource.getBrands,
  createBrand: ProductBrandAPIDataSource.createBrand,
  updateBrand: ProductBrandAPIDataSource.updateBrand,
  deleteBrand: ProductBrandAPIDataSource.deleteBrand,
  getTags: ProductTagAPIDataSource.getTags,
  createTag: ProductTagAPIDataSource.createTag,
  updateTag: ProductTagAPIDataSource.updateTag,
  deleteTag: ProductTagAPIDataSource.deleteTag,
  getProductTypes: ProductTypeAPIDataSource.getProductTypes,
  createProductType: ProductTypeAPIDataSource.createProductType,
  updateProductType: ProductTypeAPIDataSource.updateProductType,
  deleteProductType: ProductTypeAPIDataSource.deleteProductType
};

// Export combined as default ProductAPIDataSource for backward compatibility
export const ProductAPIDataSource = ProductAPIDataSourceCombined;

